<lm-application-menu-settings-dialog>
</lm-application-menu-settings-dialog>
